/**
 * The reader's own IANA time zone, e.g. `America/Los_Angeles`.
 *
 * The usage chart's days are the reader's days, not the server's: a request
 * made at 5pm Pacific belongs on that afternoon's bar, and bucketing it in UTC
 * put it on the next one. The gateway does the bucketing, so it has to be told
 * which zone to bucket in.
 *
 * Empty when the environment cannot answer, which the gateway reads as UTC.
 */
export const browserTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
};
